<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-input v-model="listQuery.keyword" placeholder="请输入用户昵称/姓名/手机号/专属号/openid" style="width: 350px;" class="filter-item" clearable/>
      <el-input v-model="listQuery.identity_card" placeholder="请输入身份证号" style="width: 200px;" class="filter-item" clearable/>
      <el-input v-model="listQuery.major" placeholder="请输入专业" style="width: 200px;" class="filter-item" clearable/>
      <el-input v-model="listQuery.class" placeholder="请输入班级" style="width: 200px;" class="filter-item" clearable/>
<!--      <el-select class="filter-item" v-model="listQuery.member_level" placeholder="积分等级" style="width: 160px" clearable>-->
<!--        <el-option v-for="item in memberLevels" :key="item.level" :label="item.name" :value="item.level">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--      <el-select class="filter-item" v-model="listQuery.member_purchase_level" placeholder="已购等级" style="width: 160px" clearable>-->
<!--        <el-option v-for="item in memberPurchaseLevels" :key="item.level" :label="item.name" :value="item.level">-->
<!--        </el-option>-->
<!--      </el-select>-->
      <el-select class="filter-item" v-model="listQuery.sort" placeholder="按字段排序" style="width: 160px" clearable>
        <el-option label="积分" value="integral"></el-option>
        <el-option label="订单量" value="order_count"></el-option>
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <download-excel :fields="json_fields" :fetch="handleExport" type="xls" name="用户列表.xls" worksheet="用户列表">
        <el-button type="success" :loading="exportLoading">导出</el-button>
      </download-excel>
    </div>
    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column align="center" label="ID" width="60">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="openid" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.openid }}
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="专属号" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.u_no }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="微信" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <img :src="scope.row.avatar" class="user-avatar">
            <span>{{ scope.row.nickname }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="性别" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.gender == 0">未设置</span>
          <span v-else-if="scope.row.gender == 1">男</span>
          <span v-else-if="scope.row.gender == 2">女</span>
        </template>
      </el-table-column>
      <el-table-column label="身份证号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.identity_card }}
        </template>
      </el-table-column>
      <el-table-column label="专业" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.major }}
        </template>
      </el-table-column>
      <el-table-column label="班级" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.class }}
        </template>
      </el-table-column>
      <el-table-column label="用户余额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.balance }}
        </template>
      </el-table-column>
      <el-table-column label="用户积分" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.integral }}
        </template>
      </el-table-column>
      <el-table-column label="充值会员等级" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.current_member ? scope.row.current_member.name : "无" }}
        </template>
      </el-table-column>
      <el-table-column label="推广钱包余额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.wallet ? scope.row.wallet.balance : "0.00" }}
        </template>
      </el-table-column>
<!--      <el-table-column label="积分等级" min-width="100" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          Lv.{{ scope.row.member_level }} {{scope.row.level.name}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="已购等级" min-width="80" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          {{ scope.row.purchase_level ? scope.row.purchase_level.name : '无' }}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="订单量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_count }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="注册时间" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="240" class-name="small-padding fixed-width">
        <template slot-scope="scope">
<!--          <el-button type="primary" size="mini">业务员</el-button>-->
<!--          <el-button type="primary" size="mini">商家</el-button>-->
          <el-button type="primary" size="mini" @click="handleUpdateUserBalance(scope.row)" v-if="user.user.type === 'admin'">修改用户余额</el-button>

          <el-button type="primary" size="mini" @click="handleUpdateUserIntegral(scope.row)" v-if="user.user.type === 'admin'">修改用户积分</el-button>

          <el-button type="success" size="mini" @click="handleUserBalanceLog(scope.row)">用户余额明细</el-button>

          <el-button type="success" size="mini" @click="handleUserIntegralLog(scope.row)">用户积分明细</el-button>

          <el-button type="success" size="mini" @click="handleUserWalletLog(scope.row)">推广钱包明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 修改用户余额 -->
    <el-dialog title="修改用户余额" :visible.sync="dialogVisibleUpdateUserBalance" width="60%" :close-on-click-modal="false">
      <el-form ref="updateUserBalanceForm" :rules="updateUserBalanceRules" :model="updateUserBalanceForm" label-width="150px">
        <el-form-item label="操作金额" prop="amount">
          <el-input-number v-model="updateUserBalanceForm.amount" controls-position="right" :precision="2"></el-input-number>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input v-model="updateUserBalanceForm.remark" type="textarea"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleUpdateUserBalance = false">取消</el-button>
        <el-button type="primary" @click="saveDataUpdateUserBalance" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 修改用户余额 -->

    <!-- 修改用户积分 -->
    <el-dialog title="修改用户积分" :visible.sync="dialogVisibleUpdateUserIntegral" width="60%" :close-on-click-modal="false">
      <el-form ref="updateUserIntegralForm" :rules="updateUserIntegralRules" :model="updateUserIntegralForm" label-width="150px">
        <el-form-item label="操作积分" prop="integral">
          <el-input-number v-model="updateUserIntegralForm.integral" controls-position="right" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input v-model="updateUserIntegralForm.remark" type="textarea"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleUpdateUserIntegral = false">取消</el-button>
        <el-button type="primary" @click="saveDataUpdateUserIntegral" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 修改用户积分 -->
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
import downloadExcel from "vue-json-excel";

export default {
  components: {
    downloadExcel
  },
  data() {
    return {
      memberLevels: [],
      memberPurchaseLevels: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        school_id: "",
        keyword: "",
        identity_card: "",
        major: "",
        class: "",
        member_level: "",
        member_purchase_level: "",
        sort: "",
      },
      btnLoading: false,
      json_fields: {
        ID: "id",
        openid: "openid",
        姓名: "name",
        手机号: {
          field: "phone",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        专属号: "u_no",
        昵称: "nickname",
        性别: {
          field: "gender",
          callback: (value) => {
            if (value === 0) return "未设置";
            else if (value === 1) return "男";
            else if (value === 2) return "女";
            else return "";
          }
        },
        身份证号: {
          field: "identity_card",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        专业: "major",
        班级: "class",
        用户余额: "balance",
        用户积分: "integral",
        充值会员等级: {
          field: "current_member.name",
          callback: (value) => {
            if (value) return value;
            else return "无";
          }
        },
        推广钱包余额: {
          field: "wallet.balance",
          callback: (value) => {
            if (value) return value;
            else return "0.00";
          }
        },
        订单量: "order_count",
        注册时间: {
          field: "created_at",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
      },
      exportLoading: false,
      // 修改用户余额
      dialogVisibleUpdateUserBalance: false,
      updateUserBalanceForm: {
        id: "",
        amount: undefined,
        remark: "",
      },
      updateUserBalanceRules: {
        amount: [{ required: true, message: "操作金额不能为空", trigger: "blur" }],
      },
      // 修改用户积分
      dialogVisibleUpdateUserIntegral: false,
      updateUserIntegralForm: {
        id: "",
        integral: undefined,
        remark: "",
      },
      updateUserIntegralRules: {
        integral: [{ required: true, message: "操作积分不能为空", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getList();
    this.getMemberLevels();
    this.getMemberPurchaseLevels();
  },
  computed: {
    ...mapGetters(["schools", "school_id","user"])
  },
  watch: {
    school_id(newVal, oldVal) {
      this.listQuery.school_id = newVal;
      this.getList();
    },
  },
  methods: {
    getList() {
      this.listQuery.school_id = this.school_id;
      this.listLoading = true;
      request({
        url: "/api/backend/user/list",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    getMemberLevels() {
      this.listLoading = true;
      request({
        url: "/api/backend/memberLevel/list",
        method: "get",
        params: {
          page: 1,
          limit: 100000,
          type: 1
        },
      }).then(response => {
        this.memberLevels = response.data.data;
      });
    },
    getMemberPurchaseLevels() {
      this.listLoading = true;
      request({
        url: "/api/backend/memberLevel/list",
        method: "get",
        params: {
          page: 1,
          limit: 100000,
          type: 2
        },
      }).then(response => {
        this.memberPurchaseLevels = response.data.data;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/user/forbid",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleExport() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.page = 1;
      listQuery.limit = this.total;
      this.exportLoading = true;
      return request({
        url: "/api/backend/user/list",
        method: "get",
        params: listQuery,
        timeout: 6000000,
      }).then(response => {
        if (response.data.data.length <= 0) {
          this.$message({
            type: "warning",
            message: "暂无记录"
          });
          return;
        }
        return response.data.data;
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    // 修改用户余额
    handleUpdateUserBalance(row) {
      this.updateUserBalanceForm = {
        id: row.id,
        amount: undefined,
        remark: "",
      };
      this.dialogVisibleUpdateUserBalance = true;
      this.$nextTick(() => {
        this.$refs["updateUserBalanceForm"].clearValidate() //清除校验结果
      })
    },
    saveDataUpdateUserBalance() {
      this.$refs["updateUserBalanceForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/user/updateUserBalance",
            method: "post",
            data: this.updateUserBalanceForm
          }).then(() => {
            this.dialogVisibleUpdateUserBalance = false;
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.getList();
          }).finally(() => {
            this.btnLoading = false;
          });
        }
      });
    },
    // 修改用户积分
    handleUpdateUserIntegral(row) {
      this.updateUserIntegralForm = {
        id: row.id,
        integral: undefined,
        remark: "",
      };
      this.dialogVisibleUpdateUserIntegral = true;
      this.$nextTick(() => {
        this.$refs["updateUserIntegralForm"].clearValidate() //清除校验结果
      })
    },
    saveDataUpdateUserIntegral() {
      this.$refs["updateUserIntegralForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/user/updateUserIntegral",
            method: "post",
            data: this.updateUserIntegralForm
          }).then(() => {
            this.dialogVisibleUpdateUserIntegral = false;
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.getList();
          }).finally(() => {
            this.btnLoading = false;
          });
        }
      });
    },
    // 用户余额明细
    handleUserBalanceLog(row) {
      this.$router.push('/user/balanceLog?user_id=' + row.id)
    },
    // 用户积分明细
    handleUserIntegralLog(row) {
      this.$router.push('/user/integralLog?user_id=' + row.id)
    },
    // 推广钱包明细
    handleUserWalletLog(row) {
      this.$router.push('/user/walletLog?user_id=' + row.id)
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
